import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconStarFillComponent } from "./med-icon-star-fill.component";

@NgModule({
  declarations: [
    MedIconStarFillComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconStarFillComponent,
  ],
})
export class MedIconStarFillModule { }
